import {
  useAssignCourseTagMutation,
  useCourseTagsQuery,
  useTagsQuery,
  useUnassignCourseTagMutation,
} from '../../api/tagApi';
import { useClientContext } from '../../hooks/useClientContext';
import { TagPickerView } from './TagPickerView';

export interface CourseTagPickerProps {
  courseId: string;
  disabled?: boolean;
}

export function CourseTagPicker({ courseId, disabled = false }: CourseTagPickerProps) {
  const { clientContext } = useClientContext();
  const { data: itemTags } = useCourseTagsQuery(courseId);
  const { data: library } = useTagsQuery({ assignedAccountId: clientContext?.id });
  const assignMutation = useAssignCourseTagMutation(courseId);
  const unassignMutation = useUnassignCourseTagMutation(courseId);

  return (
    <TagPickerView
      tags={itemTags?.items ?? []}
      allTags={library?.items ?? []}
      countKey="courseCount"
      onAssign={(tagId) => assignMutation.mutate(tagId)}
      onUnassign={(tagId) => unassignMutation.mutate(tagId)}
      disabled={disabled}
    />
  );
}
